import { Template, generate, Font } from '@pdfme/generator';
import { RecordWithTtl } from 'dns';

export const generatePdfUint8Array = (
  template: Template,
  inputs: Record<string, string>[],
  font?: Font
) => {
  return generate({ template, inputs, options: { font } }).then(pdf => {
    return pdf;
  });
};
